import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

// Pages
const ManageHotelGroups = () => import('@/views/Pages/AssistAdmin/ManageHotelGroups.vue');
const ManageHotels = () => import('@/views/Pages/AssistAdmin/ManageHotels.vue');
const ManageApplications = () => import('@/views/Pages/AssistAdmin/ManageApplications.vue');
const ManageInvoices = () => import('@/views/Pages/AssistAdmin/ManageInvoices.vue');
const TagManagement = () => import('@/views/Pages/AssistAdmin/TagManagement.vue');

export default {
    path: '/assist-admin',
    redirect: '/assist-admin/hotel-groups',
    component: DashboardLayout,
    name: 'AssistAdmin',
    meta: {requiresAuth: true, onlyAssistAdmin: true},
    children: [
        {
            path: 'hotel-groups',
            name: 'ManageHotelGroups',
            component: ManageHotelGroups,
            meta: {requiresAuth: true, onlyAssistAdmin: true},
        },
        {
            path: 'hotels',
            name: 'ManageHotels',
            component: ManageHotels,
            meta: {requiresAuth: true, onlyAssistAdmin: true},
        },
        {
            path: 'applications',
            name: 'ManageApplications',
            component: ManageApplications,
            meta: {requiresAuth: true, onlyAssistAdmin: true},
        },
        {
            path: 'invoices',
            name: 'ManageInvoices',
            component: ManageInvoices,
            meta: {requiresAuth: true, onlyAssistAdmin: true},
        },
        {
            path: 'tag-management',
            name: 'TagManagement',
            component: TagManagement,
            meta: {requiresAuth: true, onlyAssistAdmin: true},
        },
    ]
}
